import { defineComponent as _defineComponent } from 'vue'
import ConfirmDeleteModal from "@/components/ui/modals/ConfirmDeleteModal.vue";
  import { onMounted, ref } from "vue";
  import router from "@/router";
  import { useStore } from "vuex";
  import { LotMapInterface } from "@/types/LotMapInterface";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'AdminLotMap',
  setup(__props, { expose: __expose }) {
  __expose();

  const store = useStore();
  const userId = router.currentRoute.value.params.userId;
  const estateId = router.currentRoute.value.params.estateId;
  const stageId = router.currentRoute.value.params.stageId;
  const lotId = router.currentRoute.value.params.lotId;
  const map = ref<LotMapInterface | null>(null);
  const showConfirmDeleteModal = ref(false);

  onMounted(() => {
    getMap();
  });

  function getMap() {
    store.dispatch("lot/getLotMap", lotId).then((res) => {
      map.value = res.data;
    });
  }
  function toCreateMap() {
    router.push({
      name: "AdminLotMapCreate",
      params: { userId, estateId, stageId, lotId },
    });
  }
  function toEditMap() {
    router.push({
      name: "AdminLotMapUpdate",
      params: { userId, estateId, stageId, lotId },
    });
  }
  function deleteMap() {
    store.dispatch("lot/deleteLotMap", map.value._id).then(() => {
      getMap();
    });
  }

const __returned__ = { store, userId, estateId, stageId, lotId, map, showConfirmDeleteModal, getMap, toCreateMap, toEditMap, deleteMap, ConfirmDeleteModal, onMounted, ref, get router() { return router }, get useStore() { return useStore }, get LotMapInterface() { return LotMapInterface } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})